import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

const NetworkFormSuccess = ({ message }) => (
  <div className="success-state">
    <h3>¡Enviado!</h3>
    <p>{message}</p>
    <p>¡Échale un vistazo a las empresas publicadas!</p>
    <div className="success-state__actions">
      <Link to="/catalogo-red-empresas">
        <Button secondary>Directorio empresarial</Button>
      </Link>
    </div>
  </div>
);

export default NetworkFormSuccess;
